import React from "react";
import { Button } from "semantic-ui-react";
import { DownloadInfo } from "../../types";

interface DownloadConfirmDialogProps {
  showDialog: boolean;
  downloadInfo: DownloadInfo | null;
  isLoadingAssetInfo?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DownloadConfirmDialog: React.FC<DownloadConfirmDialogProps> = ({
  showDialog,
  downloadInfo,
  isLoadingAssetInfo = false,
  onConfirm,
  onCancel,
}) => {
  if (!showDialog) return null;

  // Show loading state while fetching asset info
  if (isLoadingAssetInfo) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: "30px",
            borderRadius: "8px",
            maxWidth: "500px",
            margin: "20px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            textAlign: "center",
          }}
        >
          <h3 style={{ margin: "0 0 20px 0", color: "#333" }}>Loading...</h3>
          <p style={{ margin: "0 0 20px 0", color: "#666", lineHeight: "1.5" }}>
            Fetching file information...
          </p>
        </div>
      </div>
    );
  }

  if (!downloadInfo) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "8px",
          maxWidth: "500px",
          margin: "20px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        }}
      >
        <h3 style={{ margin: "0 0 20px 0", color: "#333" }}>
          Confirm Download
        </h3>
        <p style={{ margin: "0 0 20px 0", color: "#666", lineHeight: "1.5" }}>
          Do you want to download the file "
          {downloadInfo.fileName || downloadInfo.blobName}"?
        </p>
        <div
          style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}
        >
          <Button
            onClick={onCancel}
            style={{ backgroundColor: "#f5f5f5", color: "#333" }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            style={{ backgroundColor: "#007bff", color: "white" }}
          >
            Download
          </Button>
        </div>
      </div>
    </div>
  );
};
